import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  equipments: [],
  services: [],
  certificates: [],
  licence: [],
  experience: [],
  profilePercentage: 0,
};

const partnerAuthSlice = createSlice({
  name: "partner",
  initialState,

  reducers: {
    logInPartner(state, action) {
      state.user = action.payload;
    },

    logOutPartner(state) {
      state.user = null;
    },
    updateUser(state,action){
      state.user = action.payload;
    },
    // equipments
    updateEquipmentsData(state, action) {
      state.equipments = action.payload;
    },

    addEquipmentsData(state, action) {
      const newEquipment = action.payload;
      state.equipments.push(newEquipment);
    },
    // services
    updateServicesData(state, action) {
      state.services = action.payload;
    },

    updateKycData(state,action){
      state.kyc=action.payload
    },

    // certificate
    updateCertificateData(state, action) {
      state.certificates = action.payload;
    },

    // licence
    updateLicenceData(state, action) {
      state.licence = action.payload;
    },
    addLicenceData(state, action) {
      state.licence.push(action.payload)
    },
    removeLicenceData(state, action) {
      console.log("sadgasfgh: ", action.payload);
      const filteredData = state.licence.filter((lic) => {
        return parseInt(lic.licence_id) !== parseInt(action.payload)
      });
      state.licence = filteredData;
    },

    // experience
    updateExperienceData(state, action) {
      state.experience = action.payload;
    },
    addExperienceData(state, action) {
      const newExperience = action.payload;
      state.experience.push(newExperience);
    },
    removeExperienceData(state, action) {
      const filteredData = state.experience.filter((exp) => {
        return parseInt(exp.experience_id) !== parseInt(action.payload)
      });
      state.experience = filteredData;
    },
    // profile Percentahe
    setProfilePercentage(state,action) {
      state.profilePercentage = action.payload;
    }
  },
});

export const {
  logInPartner,
  logOutPartner,
  updateUser,
  
  updateEquipmentsData,
  updateServicesData,
  addEquipmentsData,
  updateCertificateData,

  updateLicenceData,
  addLicenceData,
  removeLicenceData,
  updateKycData,

  updateExperienceData,
  addExperienceData,
  removeExperienceData,
  setProfilePercentage
} = partnerAuthSlice.actions;
export default partnerAuthSlice.reducer;
